// Utility functions for sanitizing user input

/**
 * Sanitizes a string by removing potentially dangerous characters and patterns
 * @param {string} input - The string to sanitize
 * @returns {string} The sanitized string
 */
export const sanitizeString = (input) => {
  if (!input || typeof input !== 'string') {
    return input;
  }

  return input
    // Remove HTML tags
    .replace(/<[^>]*>/g, '')
    // Remove null bytes
    .replace(/\0/g, '')
    // Remove control characters except newlines and spaces
    .replace(/[\x00-\x08\x0B-\x1F\x7F]/g, '')
    // Remove potentially dangerous patterns
    .replace(/javascript:/gi, '')
    .replace(/data:/gi, '')
    .replace(/vbscript:/gi, '')
    .trim();
};

/**
 * Recursively sanitizes all string values in an object
 * @param {*} data - The data to sanitize (can be any type)
 * @returns {*} The sanitized data
 */
export const sanitizeData = (data) => {
  if (!data) return data;

  if (typeof data === 'string') {
    return sanitizeString(data);
  }

  if (Array.isArray(data)) {
    return data.map(item => sanitizeData(item));
  }

  if (typeof data === 'object') {
    return Object.keys(data).reduce((acc, key) => {
      acc[key] = sanitizeData(data[key]);
      return acc;
    }, {});
  }

  return data;
}; 